import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import _ from 'lodash';
let LegalStatusModelImpl = class LegalStatusModelImpl {
    constructor() {
        this._legalStatus = proxy(null);
    }
    get legalStatus() {
        return this._legalStatus.value;
    }
    updateLegalStatus(legalStatus) {
        this._legalStatus.value = legalStatus;
    }
    getLegalStatusByCode(code, legalType) {
        return _.find(this._legalStatus.value, { codeType: legalType, code });
    }
    subscribeLegalStatus(callback) {
        const dispose = subscribe(() => this._legalStatus.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
LegalStatusModelImpl = __decorate([
    injectable()
], LegalStatusModelImpl);
export { LegalStatusModelImpl };
